import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { events: Array };

  connect() {
    this.replacePlaceholder();
    this.replaceButtonPlaceholder();
  }

  replacePlaceholder() {
    const container = this.element.closest("#calendar-container") || document.body;
    const targetParagraph = Array.from(container.querySelectorAll("p")).find(p =>
      p.innerHTML.includes("<span style=\"text-decoration: underline;\">Calendário / formulário</span>")
    );

    if (targetParagraph) {
      const calendarDiv = document.createElement("div");
      calendarDiv.id = "calendar-section";
      calendarDiv.classList.add("calendar-placeholder");
      calendarDiv.setAttribute("data-controller", "calendar");
      calendarDiv.setAttribute("data-calendar-events-value", JSON.stringify(this.eventsValue));
      calendarDiv.setAttribute("data-blog--scroll-target", "calendar");

      const infoText = document.createElement("p");
      infoText.classList.add("calendar-info");
      if (window.location.pathname.includes("/en")) {
        infoText.innerHTML = "Click on one of the highlighted dates to see more details about the event";
      } else {
        infoText.innerHTML = "Clique em uma das datas pintadas para ver mais detalhes do evento";
      }
      infoText.style.textAlign = "center";
      infoText.style.marginTop = "10px";
      infoText.style.color = "#666";
      infoText.style.fontSize = "12px";
      infoText.style.fontStyle = "italic";
      calendarDiv.appendChild(infoText);

      targetParagraph.replaceWith(calendarDiv);
      this.loadCalendar(calendarDiv);
    }
  }

  replaceButtonPlaceholder() {
    const container = this.element.closest("#calendar-container") || document.body;
    const title = window.location.pathname.includes("/en") ? "Subscribe here" : "Faça sua inscrição aqui";
    const targetButtonParagraph = Array.from(container.querySelectorAll("p")).find(p =>
      p.innerHTML.includes("<span style=\"text-decoration: underline;\">" + title + "</span>")
    );

    if (targetButtonParagraph) {
      const button = document.createElement("button");
      button.id = "calendar-button";
      if (window.location.pathname.includes("/en")) {
        button.textContent = "Sign up here";
      } else {
        button.textContent = "Faça sua inscrição aqui";
      }
      button.classList.add("eds-btn", "eds-btn--fill", "eds-btn--block");
      button.addEventListener("click", this.scrollToCalendar.bind(this));

      targetButtonParagraph.replaceWith(button);
    }
  }

  scrollToCalendar() {
    const container = this.element.closest("#calendar-container") || document.body;
    const title = window.location.pathname.includes("/en") ? "Check the calendar & sign up!" : "DATAS / CALENDÁRIO";
    const titleElement = Array.from(container.querySelectorAll("h2, h3, h4")).find(h => {
      const text = h.textContent;
      const textTrim = text.trim();
      const textUpper = textTrim.toUpperCase();
      const titleUpper = title.toUpperCase();
      return textUpper.includes(titleUpper);
    });

    if (titleElement) {
      const menuHeight = document.querySelector("header")?.offsetHeight || 0;
      const elementPosition = titleElement.offsetTop;
      const isMobile = window.innerWidth <= 768;
      const offsetAdjustment = isMobile ? -20 : 150;

      setTimeout(() => {
        window.scrollTo({
          top: elementPosition - menuHeight + offsetAdjustment,
          behavior: "smooth"
        });
      }, 100);
    }
  }

  async loadCalendar(element) {
    try {
      const { Calendar } = await import("@fullcalendar/core");
      const { default: dayGridPlugin } = await import("@fullcalendar/daygrid");

      const calendar = new Calendar(element, {
        plugins: [dayGridPlugin],
        initialView: "dayGridMonth",
        events: this.eventsValue,
        locale: window.location.pathname.includes("/en") ? "en-us" : "pt-br",
        height: "auto",
        showNonCurrentDates: false,
        fixedWeekCount: false,
        eventContent: function(info) {
          const colorMap = {
            "tour": "#6f6530",
            "raizes": "#f1c40f"
          };

          const eventColor = colorMap[info.event.extendedProps.kind] || "#6f6530";
          const isMobile = window.innerWidth <= 1000;

          const content = document.createElement("div");
          content.innerHTML = info.event.title;
          content.style.backgroundColor = eventColor;
          content.style.color = "#fff";
          if (isMobile) {
            content.style.fontSize = "2.5vw";
            content.style.paddingTop = "10px";
          } else {
            content.style.fontSize = "13px";
            content.style.paddingTop = "10px";
          }
          content.style.textAlign = "left";
          content.style.display = "flex";
          content.style.alignItems = "center";
          content.style.justifyContent = "center";
          content.style.height = "100%";

          return { domNodes: [content] };
        },
        headerToolbar: {
          start: "title",
          center: "",
          end: "prev,next"
        },
        validRange: function() {
          const today = new Date();
          const endOfYear = new Date(today.getFullYear() + 1, 11, 31);
          return {
            start: today,
            end: endOfYear
          };
        },
        eventClick: function(info) {
          window.location.href = info.event.url;
          info.jsEvent.preventDefault();
        }
      });

      calendar.render();
    } catch (error) {
      console.error("Erro ao carregar o calendário:", error);
    }
  }
}
